define("settings/controllers/subscription/billing", ["exports", "@ember/controller", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency-decorators"], function (_exports, _controller, _service, _utils, _tracking, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let BillingController = (_class = class BillingController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "cache", _descriptor3, this);

      _initializerDefineProperty(this, "payment", _descriptor4, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);

      _initializerDefineProperty(this, "stripe", _descriptor6, this);

      _initializerDefineProperty(this, "creditCard", _descriptor7, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get hasSavedAddress() {
      return this.address.isSavedAddressValid;
    }

    get showAddress() {
      return this.address.addressCollectionEnabled && (0, _utils.isPresent)(this.currentAccount.stripeCustomerId);
    }

    *handleStripeCard(token) {
      yield this.stripe.updateCard(token);
      this.cache.remove('card');
      this.creditCard = yield this.payment.retrieveCard.perform();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "creditCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleStripeCard", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleStripeCard"), _class.prototype)), _class);
  _exports.default = BillingController;
});